import styles from "./skeletons.module.scss";

function AppSkeleton({
  height,
  width,
  baseColor = "",
  highlightColor,
  variant = "text",
  className,
}) {
  let theme = "";
  try {
    theme = window.sessionStorage.getItem("theme") || "";
  } catch (e) {
    theme = "";
  }
  let themeBaseColor = "#1b2047";
  let themeHighlightColor = "#040721";
  if (theme) {
    themeBaseColor = theme === "light" ? "#dadada" : "#252525";
    themeHighlightColor = theme === "light" ? "#ffffff" : "#646464";
  }

  const appBaseColor = baseColor || themeBaseColor;
  const appHighlightColor = highlightColor || themeHighlightColor;

  const resolvedHeight = typeof height === "number" ? `${height}px` : height;
  const resolvedWidth = typeof width === "number" ? `${width}px` : width;

  const radius =
    variant === "circular"
      ? "9999px"
      : variant === "rounded"
        ? "12px"
        : "4px";

  return (
    <div
      className={`${styles.skeleton} ${className || ""}`.trim()}
      style={{
        height: resolvedHeight,
        width: resolvedWidth,
        "--skeleton-base": appBaseColor,
        "--skeleton-highlight": appHighlightColor,
        "--skeleton-radius": radius,
      }}
      aria-hidden="true"
    />
  );
}

export default AppSkeleton;
